import { theme } from 'rimble-ui'

export const appTheme = {
    ...theme,
    colors: {
        ...theme.colors,
        primary: '#006BA6'
    },
}